var _switch;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCompare = function SvgCompare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 48 48"
  }, props), _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M25.5 16.064h9.815v-3h-22.63v3H22.5v23.311h-6.157v3h15.315v-3H25.5zm-3-10.439h3V11.2h-3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.901 17.671-7.658 13.162 7.658 3.031 7.658-3.031zm-3.312 11.656 3.312-5.691 3.312 5.691-3.312 1.311zM12.1 17.671 4.442 30.833l7.658 3.031 7.658-3.031zM8.788 29.327l3.311-5.691 3.312 5.691-3.311 1.311z"
  })))));
};
export default SvgCompare;